import { render, staticRenderFns } from "./public-document.vue?vue&type=template&id=6e864a30&"
import script from "./public-document.vue?vue&type=script&lang=js&"
export * from "./public-document.vue?vue&type=script&lang=js&"
import style0 from "./public-document.vue?vue&type=style&index=0&id=6e864a30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports